/**
 * GOYA LISBOA — translations
 *
 * Languages: EN (default), PT (Português), ES (Español).
 *
 * Voice: GOYA LISBOA is an Iberian Chic boutique that *curates* pieces.
 * It does NOT produce, manufacture, hand-finish, hand-stitch or hand-cut anything.
 * It does NOT have a physical studio / atelier / address.
 * Keep the romantic, editorial tone — but framed around discovery, curation, edits.
 */

export const LANGS = [
  { code: "en", label: "English" },
  { code: "pt", label: "Português" },
  { code: "es", label: "Español" },
];

const en = {
  "nav.newIn": "New Arrivals",
  "nav.newArrivals": "New Arrivals",
  "nav.novidades": "New In",
  "nav.collection": "Collection",
  "nav.trending": "Trending",
  "nav.dresses": "Dresses",
  "nav.tops": "Blouses, Shirts & Tops",
  "nav.tops.short": "Tops",
  "nav.trousers": "Trousers",
  "nav.skirts": "Skirts",
  "nav.jackets": "Jackets",
  "nav.totalLook": "Total Look",
  "nav.sale": "Sale",
  "nav.skirtsTrousers": "Skirts & Trousers",
  "nav.shoes": "Shoes",
  "nav.knitwear": "Knitwear",
  "nav.accessories": "Accessories",
  "nav.journal": "Journal",
  "nav.contact": "Contact",
  "nav.faq": "FAQ",
  "nav.about": "About us",
  // About us page
  "about.eyebrow": "MEET THE FOUNDERS",
  "about.title": "Two sisters, one Lisbon.",
  "about.photo.alt": "The two founders of GOYA LISBOA",
  "about.photo.caption": "GOYA · SINCE 30",
  "about.intro1": "We're the twin sisters behind GOYA LISBOA. We just turned 30 — a milestone we celebrated by turning a lifelong obsession with fashion into a boutique that actually feels like us: bright, warm, unapologetically feminine.",
  "about.intro2": "From Lisbon we curate pieces we've loved and worn ourselves — the scalloped blouses, gingham dresses and warm-weather staples we couldn't stop reaching for, and figured you'd love them just as much.",
  "about.twins": "And yes — we really are twins. No, we won't tell you who's the older one.",
  "about.pillars.eyebrow": "WHAT WE STAND FOR",
  "about.pillars.title": "Four things we won't compromise on.",
  "about.pillars.trust.title": "Trust",
  "about.pillars.trust.body": "Fair pricing, honest sizing, real photos — no filters that hide the fabric. If it's not right, we'll make it right.",
  "about.pillars.quality.title": "Quality",
  "about.pillars.quality.body": "Every seam, every scallop, every button — inspected by us in Lisbon before it ships to you.",
  "about.pillars.fun.title": "Fun",
  "about.pillars.fun.body": "Fashion should make you smile in the mirror. Playful prints, sunny colours, pieces that spark a mood.",
  "about.pillars.passion.title": "Passion",
  "about.pillars.passion.body": "We have a tremendous passion for this — and an eye for it, if we say so ourselves.",
  "about.story.eyebrow": "OUR STORY",
  "about.story.title": "How GOYA became a thing.",
  "about.story.p1": "It started, as good things do, over coffee on the Lisbon waterfront. We'd just finished a summer of raiding Andalusian markets and Cycladic craft stalls, sending each other reels of dresses we couldn't stop thinking about.",
  "about.story.p2": "The friends and family who saw our finds kept asking where we got them — so we did what any twin sisters with too much taste and no chill would do: we opened a boutique.",
  "about.story.p3": "GOYA LISBOA is our love letter to Iberian summer — the bright yellows of a Setúbal marigold, the crisp whites of a Santorini afternoon, and the slow, sun-warmed evenings where a good dress makes the whole night better.",
  "about.signoff": "With love from Lisbon,",
  "about.signoff.sign": "— THE GOYA SISTERS",
  "about.cta.shop": "Shop new arrivals",
  "about.cta.follow": "FOLLOW US ON INSTAGRAM →",
  "nav.shipping": "Shipping",
  "nav.returns": "Returns",
  "nav.sizeGuide": "Size Guide",
  "header.account": "Account",
  "header.openCart": "Open cart",
  "header.openMenu": "Open menu",
  "header.openSearch": "Search",
  "header.categories": "Categories",
  "header.signedInAs": "SIGNED IN AS",
  "header.logout": "Log out",
  "header.signinRegister": "Sign in / Register",
  "search.placeholder": "What are you looking for?",
  "search.empty": "Nothing here yet — try another word!",
  "search.hint": "Try “dress”, “yellow”, or “Alfama”",
  "search.close": "Close",

  // Current homepage banner (Summer Sale campaign)
  "home.banner.title1": "Summer",
  "home.banner.title2": "Sale",
  "home.banner.subtitle": "Your next event never looked so good.",
  "home.banner.cta": "SHOP NOW →",

  "home.categories.eyebrow": "SHOP BY CATEGORY",
  "home.categories.title": "Pick your vibe.",
  "home.cat.tops": "Blouses, Shirts & Tops",
  "home.cat.dresses": "Dresses",
  "home.cat.trousers": "Trousers",
  "home.cat.skirts": "Skirts",
  "home.cat.jackets": "Jackets",
  "home.cat.totalLook": "Total Look",

  "home.totalLook.eyebrow": "STYLED FROM HEAD-TO-TOE",
  "home.totalLook.title": "Total Looks, ready to wear.",
  "home.totalLook.lead": "Whole outfits, curated in one click — always 10% off when you take the set.",
  "home.totalLook.cta": "Shop Total Looks",

  "home.trust.shipping.title": "Free EU shipping",
  "home.trust.shipping.sub": "Orders over €{threshold}",
  "home.trust.returns.title": "Easy returns",
  "home.trust.returns.sub": "30 days, no fuss",
  "home.trust.secure.title": "Secure checkout",
  "home.trust.secure.sub": "Stripe — protected",
  "home.trust.help.title": "We reply, promise",
  "home.trust.help.sub": "Same-day support",

  "home.newArrivals.eyebrow": "JUST IN",
  "home.newArrivals.title": "New Arrivals",
  "home.newArrivals.seeAll": "See all →",
  "home.trending.eyebrow": "JUST IN",
  "home.trending.title": "New In",
  "home.trending.seeAll": "See all →",
  "home.goyagirls.title": "#GOYAGIRLS",
  "home.goyagirls.sub": "FIND MORE INSPIRATION",
  "home.goyagirls.link": "HERE",
  "home.lookbooks.eyebrow": "LOOKBOOKS",
  "home.lookbooks.title": "Get inspired with these lookbooks",
  "home.lookbooks.l1": "Nº01 — Sunday in Lisboa",
  "home.lookbooks.l2": "Nº02 — Rooftop dinner",
  "home.lookbooks.l3": "Nº03 — Late walk home",

  /* Legacy keys kept for backward-compat in un-migrated pages */
  "home.chapter": "NEW IN — SS26",
  "home.cat.skirtsTrousers": "Skirts & Trousers",
  "home.cat.shoes": "Shoes",
  "home.letter.eyebrow": "— a letter from the founder —",
  "home.letter.quote": "“We don’t do collections. We put together small piles of things we’d be sad not to own — and let them quietly find the women who love them. <accent>Querida</accent>, welcome.”",
  "home.letter.signature": "Goya — Founder",
  "home.lookbook.eyebrow": "— Lookbook nº1 —",
  "home.lookbook.title": "A Lisbon Afternoon",
  "home.lookbook.seeAll": "See every piece →",
  "home.lookbook.tag.morning": "N°01 — The morning slip",
  "home.lookbook.tag.atelier": "An afternoon at the café",
  "home.atelier.eyebrow": "— The Edit —",
  "home.atelier.title1": "An Iberian Chic",
  "home.atelier.title2": "wardrobe.",
  "home.atelier.body": "GOYA LISBOA is a small, carefully chosen edit — pieces we genuinely love and would wear ourselves. Photographed on 35mm, captioned by hand, and added to the wardrobe one at a time.",
  "home.atelier.cta": "Read the Journal",

  "collection.eyebrow": "— The current edit —",
  "collection.titleAll1": "Every piece,",
  "collection.titleAll2": "slowly",
  "collection.lead": "{n} {pieces} in the edit. Tap any photograph for the full story — fabric, fit, and what she’s wearing in the frame.",
  "collection.piece": "piece",
  "collection.pieces": "pieces",
  "collection.developing": "DEVELOPING THE FILM…",
  "filter.all": "All",
  "filter.dresses": "Dresses",
  "filter.tops": "Blouses, Shirts & Tops",
  "filter.skirts": "Skirts",
  "filter.trousers": "Trousers",
  "filter.jackets": "Jackets",
  "filter.totalLook": "Total Look",
  "filter.shoes": "Shoes",
  "filter.knitwear": "Knitwear",
  "filter.accessories": "Accessories",
  "filter.trending": "Trending",
  "filter.newArrivals": "New Arrivals",

  "sort.label": "Sort",
  "sort.featured": "Featured",
  "sort.newest": "Newest",
  "sort.priceAsc": "Price · low → high",
  "sort.priceDesc": "Price · high → low",
  "sort.nameAsc": "Name · A → Z",

  "pdp.colourSize": "Colour & size",
  "pdp.modelWearing": "Model is wearing —",
  "pdp.addToBag": "Add to bag",
  "pdp.soldOut": "Sold out",
  "pdp.added": "Added to bag ✓",
  "pdp.selectVariant": "Select a variant",
  "pdp.silentLoop": "SILENT LOOP · 3s",
  "pdp.zoom": "Zoom",
  "pdp.acc.fabric": "Fabric & care",
  "pdp.acc.fabric.body": "Cold gentle wash, dry flat. Steam, don’t iron.",
  "pdp.acc.shipping": "Shipping",
  "pdp.acc.shipping.body": "Ships in 3–5 working days across Europe. Complimentary over €250.",
  "pdp.acc.returns": "Returns",
  "pdp.acc.returns.body": "30 days, unworn and with tags. Easy returns via our portal.",
  "pdp.shopTheLook.eyebrow": "— Worn with —",
  "pdp.shopTheLook.title": "Shop the look",
  "pdp.shopTheLook.subtitle": "Add the look together and take 10% off the bundle.",
  "pdp.shopTheLook.thisPiece": "This piece",
  "pdp.shopTheLook.add": "Add the look · −10%",
  "pdp.shopTheLook.addAll": "Add the entire look · −10%",
  "pdp.reviews.eyebrow": "— she wore it —",
  "pdp.reviews.title": "Photographed by clients",
  "pdp.reviews.count": "{n} {letters} so far — photo reviews receive €10 store credit.",
  "pdp.reviews.letter": "letter",
  "pdp.reviews.letters": "letters",
  "pdp.reviews.write": "Write a review",
  "pdp.reviews.close": "Close",
  "pdp.reviews.stars": "Your stars",
  "pdp.reviews.titlePh": "A small headline…",
  "pdp.reviews.bodyPh": "Tell us where you wore it.",
  "pdp.reviews.photosPh": "Photo URL(s), comma separated",
  "pdp.reviews.submit": "Send the letter",
  "pdp.reviews.empty": "No letters yet. Be the first to write one.",
  "pdp.trending": "TRENDING 🔥",
  "pdp.stockIn": "in",
  "pdp.stockLeft": "left",
  "badge.backInStock": "Back in Stock",

  "cart.eyebrow": "— Your edit —",
  "cart.title": "The Bag",
  "cart.empty.title": "The bag is quiet.",
  "cart.empty.body": "Wander the latest edit and let something choose you.",
  "cart.browse": "Browse the edit",
  "cart.subtotal": "Subtotal",
  "cart.bundle": "Shop-the-Look bundle (−10%)",
  "cart.total": "Total",
  "cart.bundleLabel": "SHOP-THE-LOOK · 10% OFF",
  "cart.signinTip": "Have an account? <link>Sign in</link> to track orders — or checkout as a guest below.",
  "cart.checkout": "Continue to checkout",
  "cart.checkoutGuest": "Continue as guest",
  "cart.preparing": "Preparing checkout…",
  "cart.checkoutError": "We couldn't start your checkout. Please try again in a moment.",
  "cart.stripeNote": "Stripe · test mode · EUR",
  "cart.remove": "Remove",
  "cart.voucher.label": "Gift card / promo code",
  "cart.voucher.placeholder": "Enter your code",
  "cart.voucher.apply": "Apply",
  "cart.voucher.applied": "Gift card",
  "cart.voucher.remove": "Remove",
  "cart.voucher.line": "Gift card",

  "auth.eyebrow": "— LETTERS FROM HOME —",
  "auth.welcome": "Welcome back, querida.",
  "auth.join": "Join the edit.",
  "auth.signin": "Sign in",
  "auth.create": "Create account",
  "auth.namePh": "Your name",
  "auth.emailPh": "Email address",
  "auth.passwordPh": "Password (6+ characters)",
  "auth.submitSignin": "Sign in",
  "auth.submitCreate": "Create account",
  "auth.loading": "One moment…",
  "auth.foot": "Members may publish photo reviews, track orders, and receive private invitations to the next drop.",

  "footer.tagline": "Feel-good fashion, shipped from Lisboa.",
  "footer.body": "Playful pieces, always with a little Iberian sun.",
  "footer.emailPh": "Your email, for the good stuff",
  "footer.subscribe": "Sign me up",
  "footer.newsletter.title": "Join the GOYA edit",
  "footer.newsletter.sub": "New drops, sales, and Iberian sunshine — straight to your inbox. No spam.",
  "footer.newsletter.placeholder": "your@email.com",
  "footer.newsletter.success": "You're in — merci beaucoup!",
  "footer.newsletter.already": "You're already subscribed — merci beaucoup!",
  "footer.newsletter.error": "Something went wrong. Please try again.",
  "footer.col.shop": "Shop",
  "footer.col.help": "Help",
  "footer.col.about": "About",
  "footer.col.follow": "Follow",
  "footer.help.contact": "Contact us",
  "footer.help.faq": "FAQ",
  "footer.help.shipping": "Shipping & Delivery",
  "footer.help.returns": "Returns & Refunds",
  "footer.help.sizeGuide": "Size Guide",
  "footer.help.trackOrder": "Track your order",
  "footer.about.story": "Our Story",
  "footer.about.stores": "Stockists",
  "footer.about.careers": "Careers",
  "footer.about.press": "Press",
  "footer.follow.ig": "Instagram",
  "footer.follow.tt": "TikTok",
  "footer.follow.pin": "Pinterest",
  "footer.payment": "Secure payments via Stripe",
  "footer.trust.returns.title": "14-day returns",
  "footer.trust.returns.sub": "Free & simple, no questions asked",
  "footer.trust.shipping.title": "Ships from Lisbon",
  "footer.trust.shipping.sub": "Hand-packed in 1–2 business days",
  "footer.trust.secure.title": "Secure checkout",
  "footer.trust.secure.sub": "Stripe · Multibanco · MB WAY",
  "footer.trust.freeshipping.title": "Free EU shipping",
  "footer.trust.freeshipping.sub": "Orders over €{threshold}",
  "footer.copy": "© GOYA LISBOA {year} — Made with ♥ in Lisboa",
  /* Legacy keys */
  "footer.line1": "Feel-good fashion,",
  "footer.line2": "shipped from Lisboa.",
  "footer.atelier": "Shop",
  "footer.house": "Help",
  "footer.house.care": "Shipping & Delivery",
  "footer.house.alter": "Size Guide",
  "footer.house.visits": "Stockists",
  "footer.house.contact": "Contact",
  "footer.atelier.all": "All Pieces",
  "footer.atelier.dresses": "Dresses",
  "footer.atelier.knitwear": "Total Look",
  "footer.atelier.journal": "Journal",
  "footer.photo": "Photographed with love — Lisboa · Sevilla · Barcelona",

  "checkout.eyebrow": "— Checkout —",
  "checkout.polling": "Developing your order…",
  "checkout.polling.body": "A moment while Stripe confirms the payment. Like a film roll, this takes a few seconds.",
  "checkout.paid": "Obrigada, querida.",
  "checkout.paid.body": "Your order is confirmed. We’ll send you a tracking link by email shortly.",
  "checkout.paid.return": "Return home",
  "checkout.paid.viewOrder": "View order status",
  // Order status + account orders
  "order.eyebrow": "ORDER",
  "order.eyebrow.pending": "PROCESSING",
  "order.pending.title": "Your payment is confirming…",
  "order.pending.body": "Hang tight — this usually takes a few seconds. You'll get an email as soon as it's confirmed.",
  "order.notFound.title": "Order not found",
  "order.notFound.body": "We couldn't find an order for that link. Check your inbox for the confirmation email.",
  "order.notFound.back": "Continue shopping",
  "order.loading": "LOADING",
  "order.items": "ITEMS",
  "order.subtotal": "Subtotal",
  "order.shipping": "Shipping",
  "order.total": "Total",
  "order.shipTo": "SHIP TO",
  "order.trackingNumber": "TRACKING NUMBER",
  "order.continue": "Continue shopping",
  "order.status.paid": "Paid",
  "order.status.preparing": "Preparing",
  "order.status.shipped": "Shipped",
  "order.status.delivered": "Delivered",
  "order.status.refunded": "Refunded",
  "order.status.cancelled": "Cancelled",
  "account.orders.title": "My orders",
  "account.orders.count": "so far",
  "account.orders.loading": "Loading your orders…",
  "account.orders.empty": "No orders yet — your first purchase will appear here.",
  "account.orders.items": "items",
  "checkout.expired": "The session expired.",
  "checkout.expired.body": "Nothing was charged. Your bag is waiting for you.",
  "checkout.expired.back": "Back to the edit",
  "checkout.pending": "Still developing…",
  "checkout.pending.body": "Stripe is taking a little longer than usual. Your receipt will arrive by email.",
  "checkout.failed": "Something didn’t print.",
  "checkout.failed.body": "We couldn’t confirm the payment. Please try again or contact us.",
  "account.eyebrow": "— Account · Querida —",
  "account.welcome": "Welcome back, {name}.",
  "account.lead": "Your letters live here. Reviews you write appear on each product page beneath the photograph.",
  "account.email": "Email",
  "account.since": "Member since",
  "account.sinceValue": "Today, the prettiest day of the week.",
  "account.continue": "Continue shopping",
  "account.logout": "Log out",
  "journal.eyebrow": "— Journal · Issue Nº1 —",
  "journal.title": "Field notes",
  "home.journal.title": "Stories from the boutique",
  "home.journal.viewAll": "Read the Journal",
  "journal.readOn": "Read on →",
  "journal.a1.title": "What is Iberian Chic, exactly?",
  "journal.a1.body": "A small essay on terracotta light, slow looking, and the dignity of imperfection.",
  "journal.a2.title": "How we shoot on 35mm",
  "journal.a2.body": "Notes on Portra 400, golden hour, and why digital flattens what film keeps.",
  "journal.a3.title": "A guide to slow shopping",
  "journal.a3.body": "Twelve questions to ask before you buy — and one to ask after.",

  "lang.title": "Language",

  "nav.viewAll": "View all",
  "waitlist.oosLabel": "Out of stock",
  "waitlist.title": "Notify me when it's back",
  "waitlist.body": "We'll email you the moment it's restocked. No spam.",
  "waitlist.variantPrefix": "",
  "waitlist.emailPlaceholder": "Your email",
  "waitlist.cta": "Notify me",
  "waitlist.ctaLoading": "Adding…",
  "waitlist.confirmed": "You're on the list — check your inbox for a confirmation.",
  "waitlist.error": "Something went wrong. Please try again.",

  "badge.uniquePiece": "Unique piece",
  "badge.onlyOneLeft": "Only 1 left",
  "badge.onlyNLeft": "Only {n} left",

  "seo.siteName": "GOYA LISBOA",

  "seo.title.home": "GOYA LISBOA",
  "seo.desc.home": "Dresses, tops and total looks hand-picked in Lisbon. Free shipping over €120.",
  "seo.title.about": "About us — Meet the founders",
  "seo.desc.about": "GOYA LISBOA is run by twin sisters who just turned 30 — a lifelong obsession with fashion, curated for you.",
  "seo.title.journal": "Journal — Iberian Style Notes",
  "seo.desc.journal": "The GOYA LISBOA journal — style notes, editorial shoots and postcards from the Mediterranean.",
  "seo.title.account": "Account",
  "seo.desc.account": "Your GOYA LISBOA account — orders and reviews.",
  "seo.title.checkout.success": "Order Confirmed",
  "seo.desc.checkout.success": "Thank you — your order is confirmed.",
  "seo.title.collection.all": "Shop All — SS26 Cyclades Edit",
  "seo.desc.collection.all": "The full GOYA LISBOA edit — dresses, tops, skirts, trousers and total looks. Sourced from Mediterranean makers, shipped from Lisbon.",
  "seo.title.collection.dresses": "Dresses — Gingham, Linen & Scallop",
  "seo.desc.collection.dresses": "Handpicked summer dresses in gingham, linen and scalloped cotton. Free EU shipping over €{threshold}. GOYA LISBOA.",
  "seo.title.collection.tops": "Tops & Blouses — Scalloped & Embroidered",
  "seo.desc.collection.tops": "Scalloped, embroidered and hand-picked cotton tops for a bright Iberian summer. GOYA LISBOA.",
  "seo.title.collection.skirts": "Skirts — Midi, Stripe & Flare",
  "seo.desc.collection.skirts": "Curated summer skirts — striped midis, flared cottons and playful prints. GOYA LISBOA, Lisbon.",
  "seo.title.collection.trousers": "Trousers — Wide-Leg & Linen",
  "seo.desc.collection.trousers": "Breathable linen and wide-leg cotton trousers — the perfect summer weight. GOYA LISBOA.",
  "seo.title.collection.jackets": "Jackets — Lightweight Summer Layers",
  "seo.desc.collection.jackets": "Lightweight summer layers — cotton jackets, linen blazers and boxy silhouettes. GOYA LISBOA.",
  "seo.title.collection.total-look": "Total Look — Head-to-Toe Edits",
  "seo.desc.collection.total-look": "Complete head-to-toe looks — save 10% when you shop the bundle. GOYA LISBOA.",
  "seo.title.collection.new-in": "New Arrivals — Freshly Curated",
  "seo.desc.collection.new-in": "The newest additions to the GOYA LISBOA edit — freshly curated from independent Mediterranean makers.",
  "seo.title.collection.trending": "Trending Now — Most-Loved Pieces",
  "seo.desc.collection.trending": "The pieces our shoppers can't stop clicking. Trending styles at GOYA LISBOA.",
  "seo.title.collection.sale": "Sale — Sunlit Pieces at a Softer Price",
  "seo.desc.collection.sale": "Selected GOYA LISBOA pieces at a softer price. While stocks last.",

  // Help / Contact / FAQ / Shipping / Returns / Size Guide — all editable from Admin → Content (help.*)
  "help.eyebrow": "Help & Info",
  "help.back": "← Back to shop",
  "help.contact.title": "Contact us",
  "help.contact.body.1": "Drop us a line — we usually reply within a few hours (during Iberian daylight, that is).",
  "help.contact.body.2": "Email: goyalisboapt@gmail.com",
  "help.contact.body.3": "Instagram: @goyalisboa",
  "help.contact.body.4": "Based in Lisbon · shipping worldwide.",
  "help.faq.title": "FAQ",
  "help.faq.body.1": "How long does shipping take? — 2 to 5 business days across the EU.",
  "help.faq.body.2": "Can I change my size after ordering? — Yes, if we haven’t shipped yet.",
  "help.faq.body.3": "Do you restock? — Sometimes. Sign up to the newsletter to hear first.",
  "help.faq.body.4": "Is my payment secure? — Yes, everything goes through Stripe.",
  "help.shipping.title": "Shipping & Delivery",
  "help.shipping.body.1": "Free EU shipping on orders over €{threshold}.",
  "help.shipping.body.2": "Portugal: 2–3 business days.",
  "help.shipping.body.3": "European Union: 3–5 business days.",
  "help.shipping.body.4": "Rest of the world: 7–14 business days. Duties are the buyer’s responsibility.",
  "help.shipping.body.5": "A tracking link is sent to your email as soon as the parcel leaves us.",
  "help.returns.title": "Returns & Refunds",
  "help.returns.body.1": "14 days from delivery, no questions asked.",
  "help.returns.body.2": "The piece must be unworn, with tags, and in the original packaging.",
  "help.returns.body.3": "Email us at goyalisboapt@gmail.com to receive returns instructions.",
  "help.returns.body.4": "Refunds process in 5–7 business days after we receive the parcel.",
  "help.size-guide.title": "Size Guide",
  "help.size-guide.body.1": "Our sizing runs true to European standards.",
  "help.size-guide.body.2": "Between sizes? Go up — everything relaxes a touch with wear.",
  "help.size-guide.body.3": "Detailed measurements are on every product page, under the fabric note.",
  "help.size-guide.body.4": "Still unsure? Message us on Instagram @goyalisboa and we'll help you pick.",
  // Related products strip at the bottom of every PDP
  "related.title": "You may also like",
};

const pt = {
  "nav.newIn": "Novidades",
  "nav.newArrivals": "Novidades",
  "nav.novidades": "Novidades",
  "nav.collection": "Coleção",
  "nav.trending": "Em alta",
  "nav.dresses": "Vestidos",
  "nav.tops": "Blusas, Camisas & Tops",
  "nav.tops.short": "Tops",
  "nav.trousers": "Calças",
  "nav.skirts": "Saias",
  "nav.jackets": "Casacos",
  "nav.totalLook": "Total Look",
  "nav.sale": "Saldos",
  "nav.skirtsTrousers": "Saias & Calças",
  "nav.shoes": "Sapatos",
  "nav.knitwear": "Malhas",
  "nav.accessories": "Acessórios",
  "nav.journal": "Diário",
  "nav.contact": "Contacto",
  "nav.faq": "Perguntas",
  "nav.about": "Sobre nós",
  // About us page
  "about.eyebrow": "CONHECE AS FUNDADORAS",
  "about.title": "Duas irmãs, uma Lisboa.",
  "about.photo.alt": "As duas fundadoras da GOYA LISBOA",
  "about.photo.caption": "GOYA · DESDE OS 30",
  "about.intro1": "Somos as gémeas por detrás da GOYA LISBOA. Acabámos de fazer 30 anos — um marco que decidimos celebrar transformando uma paixão de vida pela moda numa boutique que finalmente parece nossa: luminosa, quente e assumidamente feminina.",
  "about.intro2": "A partir de Lisboa, selecionamos peças que adoramos e usamos nós próprias — as blusas festonadas, os vestidos de vichy e os básicos de tempo quente aos quais não conseguíamos deixar de voltar, e imaginámos que ias adorar tanto quanto nós.",
  "about.twins": "E sim — somos mesmo gémeas. Não, não te dizemos qual é a mais velha.",
  "about.pillars.eyebrow": "AQUILO EM QUE ACREDITAMOS",
  "about.pillars.title": "Quatro coisas em que não fazemos concessões.",
  "about.pillars.trust.title": "Confiança",
  "about.pillars.trust.body": "Preços justos, tamanhos honestos, fotografias reais — sem filtros que escondam o tecido. Se não estiver bem, arranjamos.",
  "about.pillars.quality.title": "Qualidade",
  "about.pillars.quality.body": "Cada costura, cada festonado, cada botão — inspecionados por nós em Lisboa antes de te chegar.",
  "about.pillars.fun.title": "Diversão",
  "about.pillars.fun.body": "A moda deve fazer-te sorrir ao espelho. Estampados alegres, cores solares, peças que criam bom humor.",
  "about.pillars.passion.title": "Paixão",
  "about.pillars.passion.body": "Temos uma paixão enorme por isto — e olho, se assim o podemos dizer.",
  "about.story.eyebrow": "A NOSSA HISTÓRIA",
  "about.story.title": "Como a GOYA se tornou coisa séria.",
  "about.story.p1": "Começou, como as coisas boas costumam começar, num café à beira-rio em Lisboa. Tínhamos acabado um verão a saquear mercados andaluzes e bancas de artesanato nas Cíclades, a mandar uma à outra vídeos de vestidos em que não conseguíamos parar de pensar.",
  "about.story.p2": "Os amigos e a família que viam os nossos achados perguntavam sempre onde os tínhamos comprado — então fizemos o que quaisquer duas gémeas com demasiado gosto e zero autocontrolo fariam: abrimos uma boutique.",
  "about.story.p3": "A GOYA LISBOA é a nossa carta de amor ao verão ibérico — os amarelos brilhantes de uma calêndula de Setúbal, os brancos ténues de uma tarde em Santorini, e os fins de tarde mornos em que um bom vestido melhora a noite inteira.",
  "about.signoff": "Com amor de Lisboa,",
  "about.signoff.sign": "— AS IRMÃS GOYA",
  "about.cta.shop": "Ver novidades",
  "about.cta.follow": "SEGUE-NOS NO INSTAGRAM →",
  "nav.shipping": "Envio",
  "nav.returns": "Devoluções",
  "nav.sizeGuide": "Guia de tamanhos",
  "header.account": "Conta",
  "header.openCart": "Abrir cesto",
  "header.openMenu": "Abrir menu",
  "header.openSearch": "Pesquisar",
  "header.categories": "Categorias",
  "header.signedInAs": "SESSÃO INICIADA COMO",
  "header.logout": "Terminar sessão",
  "header.signinRegister": "Entrar / Registar",
  "search.placeholder": "O que procura?",
  "search.empty": "Nada por aqui — tente outra palavra!",
  "search.hint": "Tente “vestido”, “amarelo” ou “Alfama”",
  "search.close": "Fechar",

  // Current homepage banner (Summer Sale campaign)
  "home.banner.title1": "Saldos",
  "home.banner.title2": "Verão",
  "home.banner.subtitle": "O teu próximo evento nunca esteve tão bem vestido.",
  "home.banner.cta": "COMPRAR AGORA →",

  "home.categories.eyebrow": "COMPRAR POR CATEGORIA",
  "home.categories.title": "Escolha o seu estilo.",
  "home.cat.tops": "Blusas, Camisas & Tops",
  "home.cat.dresses": "Vestidos",
  "home.cat.trousers": "Calças",
  "home.cat.skirts": "Saias",
  "home.cat.jackets": "Casacos",
  "home.cat.totalLook": "Total Look",

  "home.totalLook.eyebrow": "LOOK COMPLETO",
  "home.totalLook.title": "Total Looks, prontos a vestir.",
  "home.totalLook.lead": "Conjuntos completos, num só clique — sempre com 10% de desconto.",
  "home.totalLook.cta": "Ver Total Looks",

  "home.trust.shipping.title": "Envio grátis na UE",
  "home.trust.shipping.sub": "Encomendas acima de €{threshold}",
  "home.trust.returns.title": "Devolução fácil",
  "home.trust.returns.sub": "30 dias, sem complicações",
  "home.trust.secure.title": "Pagamento seguro",
  "home.trust.secure.sub": "Stripe — protegido",
  "home.trust.help.title": "Respondemos, prometido",
  "home.trust.help.sub": "Apoio no próprio dia",

  "home.newArrivals.eyebrow": "ACABADAS DE CHEGAR",
  "home.newArrivals.title": "Novidades",
  "home.newArrivals.seeAll": "Ver todas →",
  "home.trending.eyebrow": "ACABADAS DE CHEGAR",
  "home.trending.title": "Novidades",
  "home.trending.seeAll": "Ver todas →",
  "home.goyagirls.title": "#GOYAGIRLS",
  "home.goyagirls.sub": "MAIS INSPIRAÇÃO",
  "home.goyagirls.link": "AQUI",
  "home.lookbooks.eyebrow": "LOOKBOOKS",
  "home.lookbooks.title": "Inspire-se com estes lookbooks",
  "home.lookbooks.l1": "Nº01 — Domingo em Lisboa",
  "home.lookbooks.l2": "Nº02 — Jantar num terraço",
  "home.lookbooks.l3": "Nº03 — De volta a casa",

  "home.chapter": "NOVIDADES — PV26",
  "home.cat.skirtsTrousers": "Saias & Calças",
  "home.cat.shoes": "Sapatos",
  "home.letter.eyebrow": "— uma carta da fundadora —",
  "home.letter.quote": "“Não fazemos colecções. Reunimos pequenas pilhas de coisas das quais sentiríamos falta — e deixamo-las, devagar, encontrar as mulheres que as amam. <accent>Querida</accent>, bem-vinda.”",
  "home.letter.signature": "Goya — Fundadora",
  "home.lookbook.eyebrow": "— Lookbook nº1 —",
  "home.lookbook.title": "Uma tarde de Lisboa",
  "home.lookbook.seeAll": "Ver todas as peças →",
  "home.lookbook.tag.morning": "N°01 — A combinação da manhã",
  "home.lookbook.tag.atelier": "Uma tarde no café",
  "home.atelier.eyebrow": "— A Edição —",
  "home.atelier.title1": "Um guarda-roupa",
  "home.atelier.title2": "Iberian Chic.",
  "home.atelier.body": "GOYA LISBOA é uma pequena edição cuidadosamente escolhida — peças que genuinamente amamos e usaríamos. Fotografadas em 35mm, legendadas à mão, e adicionadas ao guarda-roupa, uma a uma.",
  "home.atelier.cta": "Ler o Diário",

  "collection.eyebrow": "— A edição actual —",
  "collection.titleAll1": "Cada peça,",
  "collection.titleAll2": "devagar",
  "collection.lead": "{n} {pieces} na edição. Toque numa fotografia para a história completa — tecido, caimento e o que ela está a vestir.",
  "collection.piece": "peça",
  "collection.pieces": "peças",
  "collection.developing": "A REVELAR O FILME…",
  "filter.all": "Tudo",
  "filter.dresses": "Vestidos",
  "filter.tops": "Blusas, Camisas & Tops",
  "filter.skirts": "Saias",
  "filter.trousers": "Calças",
  "filter.jackets": "Casacos",
  "filter.totalLook": "Total Look",
  "filter.shoes": "Sapatos",
  "filter.knitwear": "Malhas",
  "filter.accessories": "Acessórios",
  "filter.trending": "Em alta",
  "filter.newArrivals": "Novidades",

  "sort.label": "Ordenar",
  "sort.featured": "Em destaque",
  "sort.newest": "Mais recentes",
  "sort.priceAsc": "Preço · baixo → alto",
  "sort.priceDesc": "Preço · alto → baixo",
  "sort.nameAsc": "Nome · A → Z",

  "pdp.colourSize": "Cor e tamanho",
  "pdp.modelWearing": "A modelo veste —",
  "pdp.addToBag": "Adicionar ao cesto",
  "pdp.soldOut": "Esgotado",
  "pdp.added": "Adicionado ao cesto ✓",
  "pdp.selectVariant": "Escolha uma variante",
  "pdp.silentLoop": "LOOP SILENCIOSO · 3s",
  "pdp.zoom": "Ampliar imagem",
  "pdp.acc.fabric": "Tecido & cuidados",
  "pdp.acc.fabric.body": "Lavagem suave a frio, secar plano. Vapor — não passar a ferro.",
  "pdp.acc.shipping": "Envio",
  "pdp.acc.shipping.body": "Envio em 3–5 dias úteis em toda a Europa. Grátis acima de €250.",
  "pdp.acc.returns": "Devoluções",
  "pdp.acc.returns.body": "30 dias, por estrear e com etiquetas. Devolução fácil pelo nosso portal.",
  "pdp.shopTheLook.eyebrow": "— Usado com —",
  "pdp.shopTheLook.title": "Vista o look",
  "pdp.shopTheLook.subtitle": "Adicione o look completo e leve 10% de desconto.",
  "pdp.shopTheLook.thisPiece": "Esta peça",
  "pdp.shopTheLook.add": "Adicionar o look · −10%",
  "pdp.shopTheLook.addAll": "Adicionar o look inteiro · −10%",
  "pdp.reviews.eyebrow": "— ela vestiu-o —",
  "pdp.reviews.title": "Fotografado por clientes",
  "pdp.reviews.count": "{n} {letters} até agora — comentários com fotografia recebem €10 de crédito.",
  "pdp.reviews.letter": "carta",
  "pdp.reviews.letters": "cartas",
  "pdp.reviews.write": "Escrever um comentário",
  "pdp.reviews.close": "Fechar",
  "pdp.reviews.stars": "As suas estrelas",
  "pdp.reviews.titlePh": "Um pequeno título…",
  "pdp.reviews.bodyPh": "Conte-nos onde a usou.",
  "pdp.reviews.photosPh": "URL(s) das fotografias, separados por vírgula",
  "pdp.reviews.submit": "Enviar a carta",
  "pdp.reviews.empty": "Ainda sem cartas. Seja a primeira a escrever.",
  "pdp.trending": "EM ALTA 🔥",
  "pdp.stockIn": "em",
  "pdp.stockLeft": "restantes",
  "badge.backInStock": "Back in Stock",

  "cart.eyebrow": "— A sua edição —",
  "cart.title": "O Cesto",
  "cart.empty.title": "O cesto está em silêncio.",
  "cart.empty.body": "Passeie pela edição e deixe que algo a escolha.",
  "cart.browse": "Explorar a edição",
  "cart.subtotal": "Subtotal",
  "cart.bundle": "Conjunto Vista-o-Look (−10%)",
  "cart.total": "Total",
  "cart.bundleLabel": "VISTA-O-LOOK · 10% DESCONTO",
  "cart.signinTip": "Já tens conta? <link>Inicia sessão</link> para acompanhar encomendas — ou faz o pagamento como convidada abaixo.",
  "cart.checkout": "Continuar para pagamento",
  "cart.checkoutGuest": "Continuar como convidada",
  "cart.preparing": "A preparar o pagamento…",
  "cart.checkoutError": "Não conseguimos iniciar o pagamento. Tenta novamente daqui a instantes.",
  "cart.stripeNote": "Stripe · modo de teste · EUR",
  "cart.remove": "Remover",
  "cart.voucher.label": "Cartão-oferta / código promocional",
  "cart.voucher.placeholder": "Insere o código",
  "cart.voucher.apply": "Aplicar",
  "cart.voucher.applied": "Cartão-oferta",
  "cart.voucher.remove": "Remover",
  "cart.voucher.line": "Cartão-oferta",

  "auth.eyebrow": "— CARTAS DE CASA —",
  "auth.welcome": "Bem-vinda de volta, querida.",
  "auth.join": "Junte-se à edição.",
  "auth.signin": "Entrar",
  "auth.create": "Criar conta",
  "auth.namePh": "O seu nome",
  "auth.emailPh": "Endereço de email",
  "auth.passwordPh": "Palavra-passe (6+ caracteres)",
  "auth.submitSignin": "Entrar",
  "auth.submitCreate": "Criar conta",
  "auth.loading": "Um momento…",
  "auth.foot": "As membros podem publicar comentários com fotografias, acompanhar encomendas e receber convites privados para o próximo lançamento.",

  "footer.tagline": "Moda alegre, enviada de Lisboa.",
  "footer.body": "Peças divertidas, sempre com um raio de sol ibérico.",
  "footer.emailPh": "O seu email, para as boas notícias",
  "footer.subscribe": "Subscrever",
  "footer.newsletter.title": "Junta-te à edição GOYA",
  "footer.newsletter.sub": "Novidades, saldos e sol ibérico — directo à tua caixa de entrada. Sem spam.",
  "footer.newsletter.placeholder": "o.teu@email.com",
  "footer.newsletter.success": "Já está — muito obrigada!",
  "footer.newsletter.already": "Já estás subscrita — muito obrigada!",
  "footer.newsletter.error": "Ocorreu um erro. Tenta novamente.",
  "footer.col.shop": "Loja",
  "footer.col.help": "Ajuda",
  "footer.col.about": "Sobre",
  "footer.col.follow": "Siga-nos",
  "footer.help.contact": "Contacte-nos",
  "footer.help.faq": "Perguntas frequentes",
  "footer.help.shipping": "Envios & Entregas",
  "footer.help.returns": "Devoluções & Reembolsos",
  "footer.help.sizeGuide": "Guia de tamanhos",
  "footer.help.trackOrder": "Seguir a encomenda",
  "footer.about.story": "A nossa história",
  "footer.about.stores": "Pontos de venda",
  "footer.about.careers": "Carreiras",
  "footer.about.press": "Imprensa",
  "footer.follow.ig": "Instagram",
  "footer.follow.tt": "TikTok",
  "footer.follow.pin": "Pinterest",
  "footer.payment": "Pagamentos seguros via Stripe",
  "footer.trust.returns.title": "Devoluções em 14 dias",
  "footer.trust.returns.sub": "Grátis e simples, sem perguntas",
  "footer.trust.shipping.title": "Enviamos de Lisboa",
  "footer.trust.shipping.sub": "Embalado à mão em 1–2 dias úteis",
  "footer.trust.secure.title": "Checkout seguro",
  "footer.trust.secure.sub": "Stripe · Multibanco · MB WAY",
  "footer.trust.freeshipping.title": "Envio grátis na UE",
  "footer.trust.freeshipping.sub": "Encomendas acima de €{threshold}",
  "footer.copy": "© GOYA LISBOA {year} — Feito com ♥ em Lisboa",
  "footer.line1": "Moda alegre,",
  "footer.line2": "enviada de Lisboa.",
  "footer.atelier": "Loja",
  "footer.house": "Ajuda",
  "footer.house.care": "Envios & Entregas",
  "footer.house.alter": "Guia de tamanhos",
  "footer.house.visits": "Lojas",
  "footer.house.contact": "Contacto",
  "footer.atelier.all": "Todas as Peças",
  "footer.atelier.dresses": "Vestidos",
  "footer.atelier.knitwear": "Total Look",
  "footer.atelier.journal": "Diário",
  "footer.photo": "Fotografado com amor — Lisboa · Sevilha · Barcelona",

  "checkout.eyebrow": "— Pagamento —",
  "checkout.polling": "A revelar a sua encomenda…",
  "checkout.polling.body": "Um momento enquanto a Stripe confirma o pagamento. Como um rolo de filme, demora uns segundos.",
  "checkout.paid": "Obrigada, querida.",
  "checkout.paid.body": "A sua encomenda está confirmada. Enviaremos um link de seguimento por email em breve.",
  "checkout.paid.return": "Voltar ao início",
  "checkout.paid.viewOrder": "Ver estado da encomenda",
  // Order status + account orders
  "order.eyebrow": "ENCOMENDA",
  "order.eyebrow.pending": "A PROCESSAR",
  "order.pending.title": "A confirmar o pagamento…",
  "order.pending.body": "Aguarda um instante — normalmente demora poucos segundos. Receberás um email assim que estiver confirmado.",
  "order.notFound.title": "Encomenda não encontrada",
  "order.notFound.body": "Não encontrámos nenhuma encomenda com este link. Verifica o email de confirmação.",
  "order.notFound.back": "Continuar a comprar",
  "order.loading": "A CARREGAR",
  "order.items": "ARTIGOS",
  "order.subtotal": "Subtotal",
  "order.shipping": "Envio",
  "order.total": "Total",
  "order.shipTo": "ENVIAR PARA",
  "order.trackingNumber": "NÚMERO DE SEGUIMENTO",
  "order.continue": "Continuar a comprar",
  "order.status.paid": "Pago",
  "order.status.preparing": "Em preparação",
  "order.status.shipped": "Enviado",
  "order.status.delivered": "Entregue",
  "order.status.refunded": "Reembolsado",
  "order.status.cancelled": "Cancelado",
  "account.orders.title": "As minhas encomendas",
  "account.orders.count": "até agora",
  "account.orders.loading": "A carregar as tuas encomendas…",
  "account.orders.empty": "Ainda não há encomendas — a tua primeira compra aparecerá aqui.",
  "account.orders.items": "artigos",
  "checkout.expired": "A sessão expirou.",
  "checkout.expired.body": "Nada foi cobrado. O seu cesto está à sua espera.",
  "checkout.expired.back": "Voltar à edição",
  "checkout.pending": "Ainda a revelar…",
  "checkout.pending.body": "A Stripe está a demorar mais que o habitual. O recibo chegará por email.",
  "checkout.failed": "Algo não imprimiu.",
  "checkout.failed.body": "Não foi possível confirmar o pagamento. Tente novamente ou contacte-nos.",
  "account.eyebrow": "— Conta · Querida —",
  "account.welcome": "Bem-vinda de volta, {name}.",
  "account.lead": "As suas cartas vivem aqui. Os comentários que escrever aparecem em cada página de produto, debaixo da fotografia.",
  "account.email": "Email",
  "account.since": "Membro desde",
  "account.sinceValue": "Hoje, o dia mais bonito da semana.",
  "account.continue": "Continuar a comprar",
  "account.logout": "Terminar sessão",
  "journal.eyebrow": "— Diário · Número Nº1 —",
  "journal.title": "Notas de campo",
  "home.journal.title": "Histórias da boutique",
  "home.journal.viewAll": "Ler o Journal",
  "journal.readOn": "Continuar a ler →",
  "journal.a1.title": "O que é, afinal, o Iberian Chic?",
  "journal.a1.body": "Um pequeno ensaio sobre a luz terracota, o olhar atento e a dignidade da imperfeição.",
  "journal.a2.title": "Como fotografamos em 35mm",
  "journal.a2.body": "Notas sobre Portra 400, a hora dourada, e o que o digital aplana e o filme guarda.",
  "journal.a3.title": "Um guia para comprar devagar",
  "journal.a3.body": "Doze perguntas antes de comprar — e uma para depois.",

  "lang.title": "Idioma",

  "nav.viewAll": "Ver tudo",
  "waitlist.oosLabel": "Esgotado",
  "waitlist.title": "Avisa-me quando voltar",
  "waitlist.body": "Enviamos-te um email assim que voltar ao stock. Sem spam.",
  "waitlist.variantPrefix": "",
  "waitlist.emailPlaceholder": "O teu email",
  "waitlist.cta": "Avisa-me",
  "waitlist.ctaLoading": "A juntar…",
  "waitlist.confirmed": "Estás na lista — verifica o teu email para a confirmação.",
  "waitlist.error": "Ocorreu um erro. Tenta novamente.",

  "badge.uniquePiece": "Peça única",
  "badge.onlyOneLeft": "Última peça",
  "badge.onlyNLeft": "Só restam {n}",

  "seo.siteName": "GOYA LISBOA",

  "seo.title.home": "GOYA LISBOA",
  "seo.desc.home": "Vestidos, tops e total looks escolhidos a dedo em Lisboa. Envio grátis acima de €120.",
  "seo.title.about": "Sobre nós — Conhece as fundadoras",
  "seo.desc.about": "A GOYA LISBOA é gerida por gémeas que acabaram de fazer 30 anos — uma paixão de uma vida pela moda, curada para ti.",
  "seo.title.journal": "Diário — Notas de Estilo Ibérico",
  "seo.desc.journal": "O diário GOYA LISBOA — notas de estilo, editoriais e postais do Mediterrâneo.",
  "seo.title.account": "Conta",
  "seo.desc.account": "A tua conta GOYA LISBOA — encomendas e avaliações.",
  "seo.title.checkout.success": "Encomenda Confirmada",
  "seo.desc.checkout.success": "Obrigada — a tua encomenda está confirmada.",
  "seo.title.collection.all": "Comprar tudo — Edição Cíclades SS26",
  "seo.desc.collection.all": "Toda a curadoria GOYA LISBOA — vestidos, tops, saias, calças e total looks. Selecionados no Mediterrâneo, enviados de Lisboa.",
  "seo.title.collection.dresses": "Vestidos — Vichy, Linho e Festonado",
  "seo.desc.collection.dresses": "Vestidos de verão selecionados em vichy, linho e algodão festonado. Envio grátis na UE acima de €{threshold}. GOYA LISBOA.",
  "seo.title.collection.tops": "Tops e Blusas — Festonadas e Bordadas",
  "seo.desc.collection.tops": "Blusas festonadas, bordadas e em algodão selecionadas à mão para um verão ibérico luminoso. GOYA LISBOA.",
  "seo.title.collection.skirts": "Saias — Midi, Riscas e Godé",
  "seo.desc.collection.skirts": "Saias de verão selecionadas — midi de riscas, algodões godé e padrões alegres. GOYA LISBOA, Lisboa.",
  "seo.title.collection.trousers": "Calças — Perna Larga e Linho",
  "seo.desc.collection.trousers": "Calças de linho respirável e perna larga em algodão — o peso perfeito para o verão. GOYA LISBOA.",
  "seo.title.collection.jackets": "Casacos — Camadas Leves de Verão",
  "seo.desc.collection.jackets": "Camadas leves para o verão — casacos de algodão, blazers de linho e silhuetas boxy. GOYA LISBOA.",
  "seo.title.collection.total-look": "Total Look — Conjuntos Completos",
  "seo.desc.collection.total-look": "Conjuntos completos da cabeça aos pés — poupa 10% ao comprar o conjunto. GOYA LISBOA.",
  "seo.title.collection.new-in": "Novidades — Acabadas de Chegar",
  "seo.desc.collection.new-in": "As mais recentes adições à edição GOYA LISBOA — curadas dos criadores independentes do Mediterrâneo.",
  "seo.title.collection.trending": "Em Alta — Peças Mais Amadas",
  "seo.desc.collection.trending": "As peças que as nossas clientes não conseguem parar de ver. Estilos em alta na GOYA LISBOA.",
  "seo.title.collection.sale": "Saldos — Peças com Preço Suave",
  "seo.desc.collection.sale": "Peças selecionadas GOYA LISBOA a um preço mais suave. Enquanto houver stock.",

  // Help / Contact / FAQ / Shipping / Returns / Size Guide (PT)
  "help.eyebrow": "Ajuda & Informação",
  "help.back": "← Voltar à loja",
  "help.contact.title": "Contacte-nos",
  "help.contact.body.1": "Diz olá — respondemos habitualmente em poucas horas (durante o horário ibérico).",
  "help.contact.body.2": "Email: goyalisboapt@gmail.com",
  "help.contact.body.3": "Instagram: @goyalisboa",
  "help.contact.body.4": "Baseadas em Lisboa · enviamos para todo o mundo.",
  "help.faq.title": "Perguntas frequentes",
  "help.faq.body.1": "Quanto tempo demora a entrega? — 2 a 5 dias úteis na União Europeia.",
  "help.faq.body.2": "Posso trocar o tamanho depois de comprar? — Sim, desde que ainda não tenha sido enviado.",
  "help.faq.body.3": "Fazem reposição? — Por vezes. Subscreve a newsletter para saberes primeiro.",
  "help.faq.body.4": "O pagamento é seguro? — Sim, tudo passa pela Stripe.",
  "help.shipping.title": "Envios & Entregas",
  "help.shipping.body.1": "Envio gratuito na UE em encomendas acima de €{threshold}.",
  "help.shipping.body.2": "Portugal: 2–3 dias úteis.",
  "help.shipping.body.3": "União Europeia: 3–5 dias úteis.",
  "help.shipping.body.4": "Resto do mundo: 7–14 dias úteis. Direitos aduaneiros são responsabilidade do comprador.",
  "help.shipping.body.5": "Recebes o link de seguimento por email assim que a encomenda sai do estúdio.",
  "help.returns.title": "Devoluções & Reembolsos",
  "help.returns.body.1": "14 dias desde a entrega, sem perguntas.",
  "help.returns.body.2": "A peça deve estar por usar, com etiquetas e na embalagem original.",
  "help.returns.body.3": "Escreve para goyalisboapt@gmail.com para receberes as instruções de devolução.",
  "help.returns.body.4": "Os reembolsos são processados em 5–7 dias úteis após recebermos a encomenda.",
  "help.size-guide.title": "Guia de tamanhos",
  "help.size-guide.body.1": "Os nossos tamanhos seguem o padrão europeu.",
  "help.size-guide.body.2": "Entre dois tamanhos? Escolhe o maior — tudo relaxa um pouco com o uso.",
  "help.size-guide.body.3": "Medidas detalhadas em cada página de produto, por baixo da nota de tecido.",
  "help.size-guide.body.4": "Ainda com dúvidas? Manda mensagem no Instagram @goyalisboa e ajudamos-te a escolher.",
  "related.title": "Também podes gostar",
};

const es = {
  "nav.newIn": "Novedades",
  "nav.newArrivals": "Novedades",
  "nav.novidades": "Novedades",
  "nav.collection": "Colección",
  "nav.trending": "Tendencia",
  "nav.dresses": "Vestidos",
  "nav.tops": "Blusas, Camisas y Tops",
  "nav.tops.short": "Tops",
  "nav.trousers": "Pantalones",
  "nav.skirts": "Faldas",
  "nav.jackets": "Chaquetas",
  "nav.totalLook": "Total Look",
  "nav.sale": "Rebajas",
  "nav.skirtsTrousers": "Faldas y Pantalones",
  "nav.shoes": "Zapatos",
  "nav.knitwear": "Punto",
  "nav.accessories": "Accesorios",
  "nav.journal": "Diario",
  "nav.contact": "Contacto",
  "nav.faq": "Preguntas",
  "nav.about": "Sobre nosotras",
  // About us page
  "about.eyebrow": "CONOCE A LAS FUNDADORAS",
  "about.title": "Dos hermanas, una Lisboa.",
  "about.photo.alt": "Las dos fundadoras de GOYA LISBOA",
  "about.photo.caption": "GOYA · DESDE LOS 30",
  "about.intro1": "Somos las hermanas gemelas detrás de GOYA LISBOA. Acabamos de cumplir 30 — un hito que celebramos convirtiendo una obsesión de siempre por la moda en una boutique que por fin nos representa: luminosa, cálida y sin complejos.",
  "about.intro2": "Desde Lisboa curamos piezas que hemos amado y llevado nosotras mismas — las blusas festoneadas, los vestidos de vichy y los básicos de verano a los que no podíamos dejar de volver, y pensamos que a ti también te encantarán.",
  "about.twins": "Y sí — de verdad somos gemelas. No, no te vamos a decir cuál es la mayor.",
  "about.pillars.eyebrow": "EN LO QUE CREEMOS",
  "about.pillars.title": "Cuatro cosas en las que no cedemos.",
  "about.pillars.trust.title": "Confianza",
  "about.pillars.trust.body": "Precios justos, tallas honestas, fotos reales — sin filtros que oculten el tejido. Si algo no está bien, lo arreglamos.",
  "about.pillars.quality.title": "Calidad",
  "about.pillars.quality.body": "Cada costura, cada festón, cada botón — inspeccionados por nosotras en Lisboa antes de llegar a ti.",
  "about.pillars.fun.title": "Diversión",
  "about.pillars.fun.body": "La moda debe hacerte sonreír frente al espejo. Estampados alegres, colores solares, piezas que despiertan buen humor.",
  "about.pillars.passion.title": "Pasión",
  "about.pillars.passion.body": "Tenemos una pasión enorme por esto — y ojo para ello, si lo podemos decir nosotras mismas.",
  "about.story.eyebrow": "NUESTRA HISTORIA",
  "about.story.title": "Cómo GOYA se convirtió en algo real.",
  "about.story.p1": "Empezó, como suelen empezar las cosas buenas, tomando un café frente al río en Lisboa. Acabábamos un verano de saquear mercados andaluces y puestos artesanos de las Cícladas, mandándonos reels de vestidos que no podíamos dejar de pensar.",
  "about.story.p2": "Los amigos y la familia que veían nuestros hallazgos nos preguntaban dónde los habíamos comprado — así que hicimos lo que harían dos hermanas gemelas con demasiado gusto y cero freno: abrimos una boutique.",
  "about.story.p3": "GOYA LISBOA es nuestra carta de amor al verano ibérico — los amarillos vibrantes de una caléndula de Setúbal, los blancos nítidos de una tarde en Santorini, y las noches templadas donde un buen vestido mejora la velada entera.",
  "about.signoff": "Con amor desde Lisboa,",
  "about.signoff.sign": "— LAS HERMANAS GOYA",
  "about.cta.shop": "Ver novedades",
  "about.cta.follow": "SÍGUENOS EN INSTAGRAM →",
  "nav.shipping": "Envíos",
  "nav.returns": "Devoluciones",
  "nav.sizeGuide": "Guía de tallas",
  "header.account": "Cuenta",
  "header.openCart": "Abrir cesta",
  "header.openMenu": "Abrir menú",
  "header.openSearch": "Buscar",
  "header.categories": "Categorías",
  "header.signedInAs": "SESIÓN INICIADA COMO",
  "header.logout": "Cerrar sesión",
  "header.signinRegister": "Entrar / Registrarse",
  "search.placeholder": "¿Qué estás buscando?",
  "search.empty": "Nada por aquí — ¡prueba otra palabra!",
  "search.hint": "Prueba “vestido”, “amarillo” o “Alfama”",
  "search.close": "Cerrar",

  // Current homepage banner (Summer Sale campaign)
  "home.banner.title1": "Rebajas",
  "home.banner.title2": "de Verano",
  "home.banner.subtitle": "Tu próximo evento nunca lució tan bien.",
  "home.banner.cta": "COMPRAR AHORA →",

  "home.categories.eyebrow": "COMPRAR POR CATEGORÍA",
  "home.categories.title": "Elige tu estilo.",
  "home.cat.tops": "Blusas, Camisas y Tops",
  "home.cat.dresses": "Vestidos",
  "home.cat.trousers": "Pantalones",
  "home.cat.skirts": "Faldas",
  "home.cat.jackets": "Chaquetas",
  "home.cat.totalLook": "Total Look",

  "home.totalLook.eyebrow": "LOOK COMPLETO",
  "home.totalLook.title": "Total Looks, listos para vestir.",
  "home.totalLook.lead": "Conjuntos completos, en un clic — siempre con un 10% de descuento.",
  "home.totalLook.cta": "Ver Total Looks",

  "home.trust.shipping.title": "Envío gratis en la UE",
  "home.trust.shipping.sub": "Pedidos superiores a €{threshold}",
  "home.trust.returns.title": "Devoluciones fáciles",
  "home.trust.returns.sub": "30 días, sin lío",
  "home.trust.secure.title": "Pago seguro",
  "home.trust.secure.sub": "Stripe — protegido",
  "home.trust.help.title": "Respondemos, prometido",
  "home.trust.help.sub": "Soporte el mismo día",

  "home.newArrivals.eyebrow": "RECIÉN LLEGADAS",
  "home.newArrivals.title": "Novedades",
  "home.newArrivals.seeAll": "Ver todas →",
  "home.trending.eyebrow": "RECIÉN LLEGADAS",
  "home.trending.title": "Novedades",
  "home.trending.seeAll": "Ver todas →",
  "home.goyagirls.title": "#GOYAGIRLS",
  "home.goyagirls.sub": "MÁS INSPIRACIÓN",
  "home.goyagirls.link": "AQUÍ",
  "home.lookbooks.eyebrow": "LOOKBOOKS",
  "home.lookbooks.title": "Inspírate con estos lookbooks",
  "home.lookbooks.l1": "Nº01 — Domingo en Lisboa",
  "home.lookbooks.l2": "Nº02 — Cena en una azotea",
  "home.lookbooks.l3": "Nº03 — Volviendo a casa",

  "home.chapter": "NOVEDADES — PV26",
  "home.cat.skirtsTrousers": "Faldas y Pantalones",
  "home.cat.shoes": "Zapatos",
  "home.letter.eyebrow": "— una carta de la fundadora —",
  "home.letter.quote": "“No hacemos colecciones. Reunimos pequeños montones de cosas que echaríamos de menos — y las dejamos, despacio, encontrar a las mujeres que las aman. <accent>Querida</accent>, bienvenida.”",
  "home.letter.signature": "Goya — Fundadora",
  "home.lookbook.eyebrow": "— Lookbook nº1 —",
  "home.lookbook.title": "Una tarde de Lisboa",
  "home.lookbook.seeAll": "Ver todas las piezas →",
  "home.lookbook.tag.morning": "N°01 — La combinación de la mañana",
  "home.lookbook.tag.atelier": "Una tarde en el café",
  "home.atelier.eyebrow": "— La Edición —",
  "home.atelier.title1": "Un armario",
  "home.atelier.title2": "Iberian Chic.",
  "home.atelier.body": "GOYA LISBOA es una pequeña edición cuidadosamente escogida — piezas que de verdad amamos y nos pondríamos. Fotografiadas en 35mm, descritas a mano, y añadidas al armario, una a una.",
  "home.atelier.cta": "Leer el Diario",

  "collection.eyebrow": "— La edición actual —",
  "collection.titleAll1": "Cada pieza,",
  "collection.titleAll2": "despacio",
  "collection.lead": "{n} {pieces} en la edición. Toque cualquier fotografía para conocer la historia completa — tejido, caída y lo que ella lleva en la imagen.",
  "collection.piece": "pieza",
  "collection.pieces": "piezas",
  "collection.developing": "REVELANDO EL CARRETE…",
  "filter.all": "Todo",
  "filter.dresses": "Vestidos",
  "filter.tops": "Blusas, Camisas y Tops",
  "filter.skirts": "Faldas",
  "filter.trousers": "Pantalones",
  "filter.jackets": "Chaquetas",
  "filter.totalLook": "Total Look",
  "filter.shoes": "Zapatos",
  "filter.knitwear": "Punto",
  "filter.accessories": "Accesorios",
  "filter.trending": "Tendencia",
  "filter.newArrivals": "Novedades",

  "sort.label": "Ordenar",
  "sort.featured": "Destacados",
  "sort.newest": "Más nuevos",
  "sort.priceAsc": "Precio · bajo → alto",
  "sort.priceDesc": "Precio · alto → bajo",
  "sort.nameAsc": "Nombre · A → Z",

  "pdp.colourSize": "Color y talla",
  "pdp.modelWearing": "La modelo lleva —",
  "pdp.addToBag": "Añadir a la cesta",
  "pdp.soldOut": "Agotado",
  "pdp.added": "Añadido a la cesta ✓",
  "pdp.selectVariant": "Elija una variante",
  "pdp.silentLoop": "BUCLE SILENCIOSO · 3s",
  "pdp.zoom": "Ampliar imagen",
  "pdp.acc.fabric": "Tejido y cuidado",
  "pdp.acc.fabric.body": "Lavado suave en frío, secar en plano. Vaporizar, no planchar.",
  "pdp.acc.shipping": "Envío",
  "pdp.acc.shipping.body": "Envío en 3–5 días laborables en toda Europa. Gratis por encima de €250.",
  "pdp.acc.returns": "Devoluciones",
  "pdp.acc.returns.body": "30 días, sin estrenar y con etiquetas. Devolución fácil por nuestro portal.",
  "pdp.shopTheLook.eyebrow": "— Llevado con —",
  "pdp.shopTheLook.title": "Compra el look",
  "pdp.shopTheLook.subtitle": "Añade el look junto y llévate un 10% de descuento.",
  "pdp.shopTheLook.thisPiece": "Esta pieza",
  "pdp.shopTheLook.add": "Añadir el look · −10%",
  "pdp.shopTheLook.addAll": "Añadir el look entero · −10%",
  "pdp.reviews.eyebrow": "— ella lo llevó —",
  "pdp.reviews.title": "Fotografiado por clientas",
  "pdp.reviews.count": "{n} {letters} hasta ahora — los comentarios con fotografía reciben €10 de crédito.",
  "pdp.reviews.letter": "carta",
  "pdp.reviews.letters": "cartas",
  "pdp.reviews.write": "Escribir un comentario",
  "pdp.reviews.close": "Cerrar",
  "pdp.reviews.stars": "Tus estrellas",
  "pdp.reviews.titlePh": "Un pequeño título…",
  "pdp.reviews.bodyPh": "Cuéntanos dónde lo llevaste.",
  "pdp.reviews.photosPh": "URL(s) de fotos, separadas por coma",
  "pdp.reviews.submit": "Enviar la carta",
  "pdp.reviews.empty": "Aún sin cartas. Sé la primera en escribir una.",
  "pdp.trending": "EN TENDENCIA 🔥",
  "pdp.stockIn": "en",
  "pdp.stockLeft": "restantes",
  "badge.backInStock": "Back in Stock",

  "cart.eyebrow": "— Tu edición —",
  "cart.title": "La Cesta",
  "cart.empty.title": "La cesta está en silencio.",
  "cart.empty.body": "Pasea por la edición y deja que algo te escoja.",
  "cart.browse": "Explorar la edición",
  "cart.subtotal": "Subtotal",
  "cart.bundle": "Conjunto Compra-el-Look (−10%)",
  "cart.total": "Total",
  "cart.bundleLabel": "COMPRA-EL-LOOK · 10% DESCUENTO",
  "cart.signinTip": "¿Tienes cuenta? <link>Inicia sesión</link> para hacer seguimiento de pedidos — o continúa como invitada abajo.",
  "cart.checkout": "Continuar al pago",
  "cart.checkoutGuest": "Continuar como invitada",
  "cart.preparing": "Preparando el pago…",
  "cart.checkoutError": "No hemos podido iniciar tu pago. Vuelve a intentarlo en un momento.",
  "cart.stripeNote": "Stripe · modo prueba · EUR",
  "cart.remove": "Quitar",
  "cart.voucher.label": "Tarjeta regalo / código promocional",
  "cart.voucher.placeholder": "Introduce el código",
  "cart.voucher.apply": "Aplicar",
  "cart.voucher.applied": "Tarjeta regalo",
  "cart.voucher.remove": "Quitar",
  "cart.voucher.line": "Tarjeta regalo",

  "auth.eyebrow": "— CARTAS DE CASA —",
  "auth.welcome": "Bienvenida de vuelta, querida.",
  "auth.join": "Únete a la edición.",
  "auth.signin": "Entrar",
  "auth.create": "Crear cuenta",
  "auth.namePh": "Tu nombre",
  "auth.emailPh": "Dirección de email",
  "auth.passwordPh": "Contraseña (6+ caracteres)",
  "auth.submitSignin": "Entrar",
  "auth.submitCreate": "Crear cuenta",
  "auth.loading": "Un momento…",
  "auth.foot": "Las miembros pueden publicar comentarios con fotos, seguir sus pedidos y recibir invitaciones privadas al próximo lanzamiento.",

  "footer.tagline": "Moda alegre, enviada desde Lisboa.",
  "footer.body": "Piezas divertidas, siempre con un rayo de sol ibérico.",
  "footer.emailPh": "Tu email, para lo bueno",
  "footer.subscribe": "Suscribirme",
  "footer.newsletter.title": "Únete a la edición GOYA",
  "footer.newsletter.sub": "Novedades, rebajas y sol ibérico — directo a tu bandeja. Sin spam.",
  "footer.newsletter.placeholder": "tu@email.com",
  "footer.newsletter.success": "Ya estás — ¡muchas gracias!",
  "footer.newsletter.already": "Ya estás suscrita — ¡muchas gracias!",
  "footer.newsletter.error": "Algo salió mal. Inténtalo de nuevo.",
  "footer.col.shop": "Tienda",
  "footer.col.help": "Ayuda",
  "footer.col.about": "Sobre",
  "footer.col.follow": "Síguenos",
  "footer.help.contact": "Contáctanos",
  "footer.help.faq": "Preguntas frecuentes",
  "footer.help.shipping": "Envíos y entregas",
  "footer.help.returns": "Devoluciones y reembolsos",
  "footer.help.sizeGuide": "Guía de tallas",
  "footer.help.trackOrder": "Sigue tu pedido",
  "footer.about.story": "Nuestra historia",
  "footer.about.stores": "Puntos de venta",
  "footer.about.careers": "Empleo",
  "footer.about.press": "Prensa",
  "footer.follow.ig": "Instagram",
  "footer.follow.tt": "TikTok",
  "footer.follow.pin": "Pinterest",
  "footer.payment": "Pagos seguros con Stripe",
  "footer.trust.returns.title": "Devoluciones en 14 días",
  "footer.trust.returns.sub": "Gratis y sencillas, sin preguntas",
  "footer.trust.shipping.title": "Enviamos desde Lisboa",
  "footer.trust.shipping.sub": "Embalado a mano en 1–2 días laborables",
  "footer.trust.secure.title": "Pago seguro",
  "footer.trust.secure.sub": "Stripe · Multibanco · MB WAY",
  "footer.trust.freeshipping.title": "Envío gratis en la UE",
  "footer.trust.freeshipping.sub": "Pedidos superiores a €{threshold}",
  "footer.copy": "© GOYA LISBOA {year} — Hecho con ♥ en Lisboa",
  "footer.line1": "Moda alegre,",
  "footer.line2": "enviada desde Lisboa.",
  "footer.atelier": "Tienda",
  "footer.house": "Ayuda",
  "footer.house.care": "Envíos y entregas",
  "footer.house.alter": "Guía de tallas",
  "footer.house.visits": "Tiendas",
  "footer.house.contact": "Contacto",
  "footer.atelier.all": "Todas las Piezas",
  "footer.atelier.dresses": "Vestidos",
  "footer.atelier.knitwear": "Total Look",
  "footer.atelier.journal": "Diario",
  "footer.photo": "Fotografiado con cariño — Lisboa · Sevilla · Barcelona",

  "checkout.eyebrow": "— Pago —",
  "checkout.polling": "Revelando tu pedido…",
  "checkout.polling.body": "Un momento mientras Stripe confirma el pago. Como un carrete, lleva unos segundos.",
  "checkout.paid": "Obrigada, querida.",
  "checkout.paid.body": "Tu pedido está confirmado. Te enviaremos un enlace de seguimiento por email en breve.",
  "checkout.paid.return": "Volver al inicio",
  "checkout.paid.viewOrder": "Ver estado del pedido",
  // Order status + account orders
  "order.eyebrow": "PEDIDO",
  "order.eyebrow.pending": "PROCESANDO",
  "order.pending.title": "Confirmando el pago…",
  "order.pending.body": "Un momento — normalmente tarda unos segundos. Recibirás un email cuando se confirme.",
  "order.notFound.title": "Pedido no encontrado",
  "order.notFound.body": "No pudimos encontrar ningún pedido con este enlace. Consulta el email de confirmación.",
  "order.notFound.back": "Seguir comprando",
  "order.loading": "CARGANDO",
  "order.items": "ARTÍCULOS",
  "order.subtotal": "Subtotal",
  "order.shipping": "Envío",
  "order.total": "Total",
  "order.shipTo": "ENVIAR A",
  "order.trackingNumber": "NÚMERO DE SEGUIMIENTO",
  "order.continue": "Seguir comprando",
  "order.status.paid": "Pagado",
  "order.status.preparing": "Preparando",
  "order.status.shipped": "Enviado",
  "order.status.delivered": "Entregado",
  "order.status.refunded": "Reembolsado",
  "order.status.cancelled": "Cancelado",
  "account.orders.title": "Mis pedidos",
  "account.orders.count": "hasta ahora",
  "account.orders.loading": "Cargando tus pedidos…",
  "account.orders.empty": "Aún no hay pedidos — tu primera compra aparecerá aquí.",
  "account.orders.items": "artículos",
  "checkout.expired": "La sesión ha caducado.",
  "checkout.expired.body": "No se cobró nada. Tu cesta te espera.",
  "checkout.expired.back": "Volver a la edición",
  "checkout.pending": "Aún revelando…",
  "checkout.pending.body": "Stripe está tardando un poco más. Tu recibo llegará por email.",
  "checkout.failed": "Algo no imprimió.",
  "checkout.failed.body": "No pudimos confirmar el pago. Inténtalo de nuevo o contáctanos.",
  "account.eyebrow": "— Cuenta · Querida —",
  "account.welcome": "Bienvenida de vuelta, {name}.",
  "account.lead": "Tus cartas viven aquí. Los comentarios que escribas aparecen en cada página de producto, bajo la fotografía.",
  "account.email": "Email",
  "account.since": "Miembro desde",
  "account.sinceValue": "Hoy, el día más bonito de la semana.",
  "account.continue": "Seguir comprando",
  "account.logout": "Cerrar sesión",
  "journal.eyebrow": "— Diario · Número Nº1 —",
  "journal.title": "Notas de campo",
  "home.journal.title": "Historias de la boutique",
  "home.journal.viewAll": "Leer el Journal",
  "journal.readOn": "Seguir leyendo →",
  "journal.a1.title": "¿Qué es exactamente el Iberian Chic?",
  "journal.a1.body": "Un pequeño ensayo sobre la luz terracota, la mirada atenta y la dignidad de la imperfección.",
  "journal.a2.title": "Cómo fotografiamos en 35mm",
  "journal.a2.body": "Notas sobre Portra 400, la hora dorada, y lo que lo digital aplana y el carrete conserva.",
  "journal.a3.title": "Una guía para comprar despacio",
  "journal.a3.body": "Doce preguntas antes de comprar — y una para después.",

  "lang.title": "Idioma",

  "nav.viewAll": "Ver todo",
  "waitlist.oosLabel": "Agotado",
  "waitlist.title": "Avísame cuando vuelva",
  "waitlist.body": "Te enviaremos un email en cuanto vuelva a estar disponible. Sin spam.",
  "waitlist.variantPrefix": "",
  "waitlist.emailPlaceholder": "Tu email",
  "waitlist.cta": "Avísame",
  "waitlist.ctaLoading": "Añadiendo…",
  "waitlist.confirmed": "Estás en la lista — revisa tu email para la confirmación.",
  "waitlist.error": "Algo salió mal. Inténtalo de nuevo.",

  "badge.uniquePiece": "Pieza única",
  "badge.onlyOneLeft": "Última pieza",
  "badge.onlyNLeft": "Solo quedan {n}",

  "seo.siteName": "GOYA LISBOA",

  "seo.title.home": "GOYA LISBOA",
  "seo.desc.home": "Vestidos, tops y total looks elegidos a mano en Lisboa. Envío gratis a partir de €120.",
  "seo.title.about": "Sobre nosotras — Conoce a las fundadoras",
  "seo.desc.about": "GOYA LISBOA está gestionada por hermanas gemelas que acaban de cumplir 30 — una pasión de toda la vida por la moda, curada para ti.",
  "seo.title.journal": "Diario — Notas de Estilo Ibérico",
  "seo.desc.journal": "El diario GOYA LISBOA — notas de estilo, editoriales y postales del Mediterráneo.",
  "seo.title.account": "Cuenta",
  "seo.desc.account": "Tu cuenta GOYA LISBOA — pedidos y reseñas.",
  "seo.title.checkout.success": "Pedido Confirmado",
  "seo.desc.checkout.success": "Gracias — tu pedido está confirmado.",
  "seo.title.collection.all": "Comprar todo — Edición Cíclades SS26",
  "seo.desc.collection.all": "Toda la selección GOYA LISBOA — vestidos, tops, faldas, pantalones y total looks. Curados en el Mediterráneo, enviados desde Lisboa.",
  "seo.title.collection.dresses": "Vestidos — Vichy, Lino y Festón",
  "seo.desc.collection.dresses": "Vestidos de verano seleccionados en vichy, lino y algodón festoneado. Envío gratis en la UE desde €{threshold}. GOYA LISBOA.",
  "seo.title.collection.tops": "Tops y Blusas — Festón y Bordado",
  "seo.desc.collection.tops": "Blusas festoneadas, bordadas y en algodón seleccionadas para un verano ibérico luminoso. GOYA LISBOA.",
  "seo.title.collection.skirts": "Faldas — Midi, Rayas y Vuelo",
  "seo.desc.collection.skirts": "Faldas de verano curadas — midi a rayas, algodones con vuelo y estampados alegres. GOYA LISBOA, Lisboa.",
  "seo.title.collection.trousers": "Pantalones — Pierna Ancha y Lino",
  "seo.desc.collection.trousers": "Pantalones de lino transpirable y pierna ancha en algodón — el peso ideal para el verano. GOYA LISBOA.",
  "seo.title.collection.jackets": "Chaquetas — Capas Ligeras de Verano",
  "seo.desc.collection.jackets": "Capas ligeras para el verano — chaquetas de algodón, blazers de lino y siluetas boxy. GOYA LISBOA.",
  "seo.title.collection.total-look": "Total Look — Conjuntos Completos",
  "seo.desc.collection.total-look": "Conjuntos completos de la cabeza a los pies — ahorra un 10% al comprar el pack. GOYA LISBOA.",
  "seo.title.collection.new-in": "Novedades — Recién Curadas",
  "seo.desc.collection.new-in": "Las últimas incorporaciones a la edición GOYA LISBOA — curadas de creadores independientes del Mediterráneo.",
  "seo.title.collection.trending": "Tendencia — Piezas Más Queridas",
  "seo.desc.collection.trending": "Las piezas que nuestras clientas no dejan de mirar. Estilos en tendencia en GOYA LISBOA.",
  "seo.title.collection.sale": "Rebajas — Piezas Solares a Precio Suave",
  "seo.desc.collection.sale": "Piezas seleccionadas GOYA LISBOA a un precio más suave. Hasta agotar existencias.",

  // Help / Contact / FAQ / Shipping / Returns / Size Guide (ES)
  "help.eyebrow": "Ayuda & Información",
  "help.back": "← Volver a la tienda",
  "help.contact.title": "Contáctanos",
  "help.contact.body.1": "Escríbenos — solemos responder en pocas horas (dentro del horario ibérico).",
  "help.contact.body.2": "Email: goyalisboapt@gmail.com",
  "help.contact.body.3": "Instagram: @goyalisboa",
  "help.contact.body.4": "Con base en Lisboa · enviamos a todo el mundo.",
  "help.faq.title": "Preguntas frecuentes",
  "help.faq.body.1": "¿Cuánto tarda el envío? — De 2 a 5 días laborables en la Unión Europea.",
  "help.faq.body.2": "¿Puedo cambiar la talla después de pedir? — Sí, siempre que aún no lo hayamos enviado.",
  "help.faq.body.3": "¿Reponéis piezas? — A veces. Suscríbete a la newsletter para enterarte primero.",
  "help.faq.body.4": "¿El pago es seguro? — Sí, todo se procesa a través de Stripe.",
  "help.shipping.title": "Envíos & Entregas",
  "help.shipping.body.1": "Envío gratuito en la UE en pedidos superiores a €{threshold}.",
  "help.shipping.body.2": "Portugal: 2–3 días laborables.",
  "help.shipping.body.3": "Unión Europea: 3–5 días laborables.",
  "help.shipping.body.4": "Resto del mundo: 7–14 días laborables. Los aranceles corren por cuenta del comprador.",
  "help.shipping.body.5": "Recibirás el enlace de seguimiento por email en cuanto el paquete salga del estudio.",
  "help.returns.title": "Devoluciones & Reembolsos",
  "help.returns.body.1": "14 días desde la entrega, sin preguntas.",
  "help.returns.body.2": "La pieza debe estar sin usar, con etiquetas y en su embalaje original.",
  "help.returns.body.3": "Escríbenos a goyalisboapt@gmail.com para recibir las instrucciones de devolución.",
  "help.returns.body.4": "Los reembolsos se procesan en 5–7 días laborables tras recibir el paquete.",
  "help.size-guide.title": "Guía de tallas",
  "help.size-guide.body.1": "Nuestras tallas siguen el estándar europeo.",
  "help.size-guide.body.2": "¿Entre tallas? Elige la mayor — todo se relaja un poco con el uso.",
  "help.size-guide.body.3": "Medidas detalladas en cada página de producto, bajo la nota del tejido.",
  "help.size-guide.body.4": "¿Aún con dudas? Escríbenos por Instagram a @goyalisboa y te ayudamos a elegir.",
  "related.title": "También te puede gustar",
};

export const TRANSLATIONS = { en, pt, es };
